<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M50 19L83 76.1577H17L50 19Z" stroke="black" stroke-width="4"/>
<path d="M50 39V61.5" stroke="black" stroke-width="4"/>
<path d="M50 69L50 65" stroke="black" stroke-width="4"/>
</svg>

</template>
